import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class IncomeClassificationsDoc  {
    _originalTypeClassName = "zERP.BO.IncomeClassificationsDoc";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
IncomeClassificationsDoc.translate = translateService;
}
this.IncomeInvoiceClassification = [];
this.Id = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IncomeInvoiceClassification:any;
static setIncomeInvoiceClassification = ($this, items) => {
                if (items == null) items = [];
                if ($this.IncomeInvoiceClassification == null) $this.IncomeInvoiceClassification = [];

                const copyItems = Common.cloneObject(items);

                while ($this.IncomeInvoiceClassification.length > 0) {
                    Domain.IncomeClassificationsDoc.removeIncomeInvoiceClassification($this, $this.IncomeInvoiceClassification[0]);
                }

                Domain.IncomeClassificationsDoc.addManyIncomeInvoiceClassification($this, copyItems);
            }
static addManyIncomeInvoiceClassification = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.IncomeClassificationsDoc.addIncomeInvoiceClassification($this, items[i]);
                }
            }
static addIncomeInvoiceClassification = ($this, item) => {
                if ($this.IncomeInvoiceClassification == null) $this.IncomeInvoiceClassification = [];
                if (item == null || $this.IncomeInvoiceClassification.indexOf(item) > -1) return;
                $this.IncomeInvoiceClassification.push(item);
}
static addRangeIncomeInvoiceClassification = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.IncomeClassificationsDoc.addIncomeInvoiceClassification($this, item));
            }
static removeIncomeInvoiceClassification = ($this, item) => {
                if ($this == null || $this.IncomeInvoiceClassification == null || $this.IncomeInvoiceClassification.indexOf(item) === -1) return;
                var _index = $this.IncomeInvoiceClassification.indexOf(item);
                $this.IncomeInvoiceClassification.splice(_index, 1);
}
static clearIncomeInvoiceClassification = ($this) => { $this.IncomeInvoiceClassification = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}